import { render } from "./PersonCard.vue?vue&type=template&id=a18bbaac"
import script from "./PersonCard.vue?vue&type=script&lang=js"
export * from "./PersonCard.vue?vue&type=script&lang=js"

import exportComponent from "/Users/macbookpro/Documents/Github/sinfoapp/sinfoapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__